'use strict';
// keyed by the node itself - a counter stored on the node would collide when the engine is loaded more than once on a page (every copy starts
// counting at 0 while the DOM nodes are shared), and clearing one node's animation would cancel an unrelated node's animation of another copy
const _animations = new WeakMap();
// private methods and properties
const _requestAnimation = (tick) => (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
const _stopAnimation = (id) => {
    if (!window.cancelAnimationFrame) {
        clearTimeout(id);
    }
    else {
        window.cancelAnimationFrame(id);
    }
};
let PARSE_DIV = null;
const SxQueryShared = {
    _notifyAnimation(node, type, id) {
        let entry = _animations.get(node);
        if (entry === undefined) {
            entry = {};
            _animations.set(node, entry);
        }
        entry[type] = id;
    },
    _clearAnimation(node, type) {
        const entry = _animations.get(node);
        if (entry !== undefined && (type in entry)) {
            _stopAnimation(entry[type]);
            delete entry[type];
        }
    },
    _requestAnimation,
    _stopAnimation,
    prefersReducedMotion() {
        return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    },
    parseHTML(str) {
        if (!PARSE_DIV) {
            PARSE_DIV = document.createElement('div');
        }
        PARSE_DIV.innerHTML = str;
        const res = Array.from(PARSE_DIV.children);
        PARSE_DIV.innerHTML = '';
        return res;
    }
};
export default SxQueryShared;
